// todo - remove scripts from call form
const customEmailFormWrapper = document.getElementById('customEmailFormWrapper');
const openCustomModalEmail = document.getElementById('openCustomModalEmail');
const closeCustomModalEmail = document.getElementById('closeCustomModalEmail');
const customContactForm = document.getElementById('CustomContactForm');

if (customEmailFormWrapper && openCustomModalEmail) {
	const toggleMainModal = () => {
		customEmailFormWrapper.classList.toggle('hidden');
		document.body.style.overflow === 'hidden'
			? (document.body.style.overflow = '')
			: (document.body.style.overflow = 'hidden');

		// click by backdrop
		const closeByBackdrop = (e) => {
			if (e.target === e.currentTarget) {
				customEmailFormWrapper.classList.add('hidden');
				document.body.style.overflow = '';
			}
		};
		if (!customEmailFormWrapper.classList.contains('hidden')) {
			customEmailFormWrapper.addEventListener('click', closeByBackdrop);
		} else {
			customEmailFormWrapper.removeEventListener('click', closeByBackdrop);
		}
	};

	// if page load after submting form
	if (window.location.hash === '#CustomContactForm') {
		toggleMainModal();
	}

	// customContactForm.addEventListener('submit', () => {
	// 	sessionStorage.setItem('recentlySubmitted', 'customContactForm');
	// });

	openCustomModalEmail.addEventListener('click', toggleMainModal);
	closeCustomModalEmail.addEventListener('click', toggleMainModal);

	//  todo - clear eventlistener if modal closed
}
